<template>
  <b-modal
    v-model="localIsVisible"
    hide-footer
    @cancel="onCancel"
  >
    <b-card>
      <h5>Editar Numero de Orden Orion</h5>

      <div class="mt-2 d-flex">
        <b-form-input 
          type="number" 
          v-model="numeroOrden"
        />
        <b-button 
          variant="primary" 
          class="ml-2"
          @click="onUpdateNumeroOrden"
        >
          Guardar
        </b-button>
      </div>
      
    </b-card>
    
  </b-modal>
</template>

<script>
import { estudioLabService, labAs400Service } from '../services';

export default {
  name: 'ModalEditarCodigoOrion',

  props: {
    isVisible: Boolean,
    item: Object
  },

  data() {
    return {
      localIsVisible: false,
      numeroOrden: ''
    }
  },

  methods: {
    onCancel() {
      this.$emit('update:item', null);
      this.localIsVisible = false;
    },

    async onUpdateNumeroOrden(){      

      const response = await labAs400Service.updateByToken(this.item.token, { codigoOrion: this.numeroOrden });

      if (response) {
        this.$swal({
          title: "Numero orden guardado!",
          text: "Numero orden ha sido guardado",
          icon: "success",
          confirmButtonColor: "#3085d6",
        }).then((result) => {
          if (result.isConfirmed) {
            this.$router.go(0);
          }
        });
      }
    }
  },

  watch: {
    isVisible(newValue) {
      this.localIsVisible = newValue;
    },

    localIsVisible(newValue) {
      this.$emit('update:isVisible', newValue);
    },
    item: {
      deep: true,
      handler() {
        this.isVisible = true;
        this.numeroOrden = this.item.numeroOrdenprise
      }
    }
  },
}
</script>